export default ({ model, fileName, fileUrl }) => ({
    files: [],
    detail: [],
    currentFile: 0,
    model,

    init(){
      const files = this.$wire.get(this.model);
      if(Array.isArray(files)){
          this.files = files.map((file) => {
              return {
                  name: file.name,
                  url: file.url
              };
          });

          return;
      }

      if (! fileName) {
          return;
      }

      this.setFiles([{
          name: fileName,
          url: fileUrl,
      }]);
    },

    removeFile(index, removeUploaded = false) {
        if(removeUploaded && this.files[index].hasOwnProperty('uploadedName')){
            this.$wire.removeUpload(this.model, this.files[index].uploadedName);
        }

        this.files[index].deleted = true;

        this.$dispatch('remove-upload');
        this.clear();
        this.$dispatch('show-progress', false);
    },

    setFiles(files) {
        this.files = Array.from(files);

        return this;
    },

    isEmpty(){
        return !this.files.length || this.files.every((file) => file.hasOwnProperty('deleted'));
    },

    onChange({ target }) {
        if(target.files.length === 0){
            return;
        }
        this.$dispatch('show-progress', true)
        this.setFiles(target.files)
            .send();
    },

    send() {
        this.getDetail(this.currentFile);

        if(this.currentFile === 0){
            this.$dispatch('uploads-started', {currentFile: this.currentFile, lastFile: this.getLastFile()});
        }

        let modelName = this.model;

        if(this.multiple){
            modelName = `${modelName}.${this.currentFile}`;
        }

        if (!this.files[this.currentFile] && this.getLastFile() === this.currentFile) {
            this.dispatchFinishedEvents();

            return;
        }

        this.$wire.upload(modelName, this.files[this.currentFile], (uploadedFilename) => {
            this.detail[this.currentFile].progress = 100;
            this.files[this.currentFile].uploadedName = uploadedFilename;

            this.$dispatch('upload-successfully');

            this.$nextTick(() => {
                if(this.currentFile === 0){
                    return;
                }

                document.getElementById(`uploads-${this.currentFile}`)
                    ?.scrollIntoView({behavior: 'smooth'});
            });

            if( this.currentFile === this.getLastFile() ) {
                this.currentFile = 0;

                this.dispatchFinishedEvents();
            } else {
                this.currentFile += 1;
                this.send();
            }
        }, () => {
            this.detail[this.currentFile].progress = 0;
            this.detail[this.currentFile].message = 'Error trying to send the file!';
        }, (event) => {
            this.detail[this.currentFile].progress = event.detail.progress;
        });
    },

    getDetail(index) {
        this.detail[index] = _.get(this.detail, index, {
            progress: 0,
            message: null
        });

        return this.detail[index];
    },

    getLastFile(){
        return this.files.length - 1;
    },

    dispatchFinishedEvents(){
        this.$wire.dispatch('drag-and-drop::uploads:finished');
        this.$dispatch('uploads-finished');
    },

    clear(){
        this.files = [];
        this.$refs.files.value = null;
        this.detail = [];
    },
});
